import { motion } from "framer-motion";
import { Megaphone, KanbanSquare, BotMessageSquare, FileText, MessagesSquare, Globe, Wallet } from "lucide-react";

const modules = [
  {
    num: "01",
    icon: Megaphone,
    title: "Integrador de anúncios",
    desc: "Webmotors, OLX, iCarros e marketplaces: estoque publicado em 45+ portais com 1 clique, sempre sincronizado.",
    span: "md:col-span-7",
  },
  {
    num: "02",
    icon: KanbanSquare,
    title: "CRM funil de vendas",
    desc: "Leads organizados em kanban, do primeiro contato ao contrato. Nenhuma oportunidade se perde.",
    span: "md:col-span-5",
  },
  {
    num: "03",
    icon: BotMessageSquare,
    title: "Agente de IA no WhatsApp",
    desc: "Pré-atendimento 24/7 que qualifica leads, responde dúvidas e agenda visitas seguindo as regras da loja.",
    span: "md:col-span-5",
  },
  {
    num: "04",
    icon: FileText,
    title: "Financeiro + NF-e",
    desc: "Contas a pagar e receber, comissões, margem por veículo e emissão de nota fiscal em um só painel.",
    span: "md:col-span-7",
  },
];

const extras = [
  { icon: MessagesSquare, label: "Central de conversas unificada" },
  { icon: Globe, label: "Site integrado aos portais" },
  { icon: Wallet, label: "Simulador multi-bancos" },
];

export const Platform = () => (
  <section id="plataforma" className="py-24 sm:py-32" data-testid="platform-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-100px" }}
        transition={{ duration: 0.8 }}
        className="max-w-2xl mb-14"
      >
        <p className="text-xs font-mono2 tracking-widest uppercase text-emerald-400 mb-3">04 — Plataforma</p>
        <h2 className="font-display text-3xl sm:text-5xl font-bold tracking-tight text-white">
          O motor invisível da <span className="text-emerald-400">operação</span>
        </h2>
        <p className="mt-4 text-slate-400">
          Por trás de cada carro vendido há um ecossistema ERP + CRM que organiza
          marketing, atendimento, contratos e financeiro em um único ambiente.
        </p>
      </motion.div>

      <div className="grid grid-cols-1 md:grid-cols-12 gap-6" data-testid="platform-bento">
        {modules.map((m, i) => (
          <motion.div
            key={m.num}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.7, delay: i * 0.1 }}
            className={`${m.span} group relative glass rounded-3xl p-8 sm:p-10 overflow-hidden hover:border-emerald-500/40 transition-colors duration-500`}
            data-testid={`platform-module-${m.num}`}
          >
            <span className="absolute -top-4 right-6 font-display text-[7rem] font-extrabold text-slate-800/40 leading-none select-none group-hover:text-emerald-500/10 transition-colors duration-500">
              {m.num}
            </span>
            <div className="relative">
              <span className="inline-flex w-12 h-12 rounded-2xl bg-emerald-500/15 items-center justify-center mb-6">
                <m.icon className="w-6 h-6 text-emerald-400" />
              </span>
              <h3 className="font-display text-xl sm:text-2xl font-bold text-white">{m.title}</h3>
              <p className="mt-3 text-sm text-slate-400 leading-relaxed max-w-md">{m.desc}</p>
            </div>
          </motion.div>
        ))}
      </div>

      <motion.div
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 0.8, delay: 0.3 }}
        className="mt-6 flex flex-wrap gap-3"
        data-testid="platform-extras"
      >
        {extras.map((e) => (
          <span key={e.label} className="inline-flex items-center gap-2 glass rounded-full px-5 py-2.5 text-sm text-slate-300">
            <e.icon className="w-4 h-4 text-emerald-400" />
            {e.label}
          </span>
        ))}
      </motion.div>
    </div>
  </section>
);
